export const DH = {
  CLOSE_BUTTON: 'close-button',
}
